import 'owl.carousel';
import MicroModal from 'micromodal';
// import Tablesaw from 'tablesaw';

require('./shortcode');

document.addEventListener('DOMContentLoaded', () => {
  function changedSlider(e) {
    const current = e.item.index;
    const $box = $(e.target).find('.owl-item').eq(current);
    const target = $box.find('.c-slider-img--full').data('target');
    // // $(".c-slider__box--mobile").html($box.html());
    // // // $('.depoimentos-section').outerHeight();
    // // var target = $('.c-slider .owl-carousel .owl-item.active .c-slider-img--full').data('target');
    // console.log(target);
    $('.c-slider__box__info').not(target).hide();
    $(`.c-slider__box__info${target}`).show();
  }

  const slider = $('.c-slider .owl-carousel').owlCarousel({
    loop: true,
    nav: false,
    dots: true,
    items: 1,
    autoplay: true,
    autoplayTimeout: 6000,
    autoplayHoverPause: true,
    onChanged: changedSlider,
    onInitialized: changedSlider,
    // dotsContainer: '.js-owl-dots',
    // autoHeight: true,
    animateOut: 'fadeOut',
    responsive: {
      0: {
        dotsContainer: '.dots-mobile',
      },
      1024: {
        dotsContainer: '.dots-desktop',
      },
    },
    // onChanged: function(e){

    // },
    onInitialized(e) {
      $('.c-slider__box').removeClass('hidden');
    },
    // animateIn: 'flipInX',
  });
});

jQuery(($) => {
  // Info Shortcode JS
  // How-to --> [info titulo="Titulo"] Conteúdo [/info]
  $('.panel-table td').shortcode({
    info() {
      const html = `<a tabindex="0" role="button" class="icon-toggle" data-trigger="focus"  data-container="body" data-placement="left" data-toggle="popover" title="${this.options.titulo}" data-content="${this.contents}"><i class="fa fa-info"></i></a>`;
      // html = '<a tabindex="0" role="button" class="icon-toggle"  data-container="body" data-placement="left" data-toggle="popover" title="' + this.options.titulo + '" data-content="'+ this.contents +'"><i class="icon-info"></i></a>';
      return html;
    },
  });

  // Complex Table

  $('.panel-collapse').on('shown.bs.collapse', function (event) {
    const originalText = $(`${$(this).attr('id')}.heading-title-content`).text();
    $(`${$(this).attr('id')}.heading-title-content`).text($('.panel-table-activator').data('opened-text'));
  });

  $('.panel-collapse').on('hidden.bs.collapse', function (event) {
    const originalText = $(`${$(this).attr('id')}.heading-title-content`).text();
    $(`${$(this).attr('id')}.heading-title-content`).text(originalText);
  });

  $(document).on('click', '.js-change-dep-modal', function (e) {
    e.stopPropagation();

    const idDepoimento = $(this).data('id');
    const home = jQuery('body').data('home');

    const link = `${home}/ajax/depoimento/${idDepoimento}/`;
    // console.log(link);
    jQuery('.modal__content').html(jQuery('.spinner').html());
    jQuery.ajaxSetup({ async: false });

    jQuery.get(link, (data) => {
      // jQuery(data).find('li.form-post-id input').val(jQuery('.post_id').val());
      jQuery('.modal__content')
        .empty()
        .html(data);
    });

    // $('#depModal').modal('show');
    return false;
  });

  $('td').removeAttr('style');
  $('table').removeAttr('style');
  $('tr').removeAttr('style');
  $('table').each((index, table) => {
    // console.log($(table).find('thead'));
    // console.log('find');
    $(table).remove('colgroup');
    if ($(table).find('thead').length == 0) {
      $(table).prepend('<thead></thead>');
      $(table).find('tr:first').prependTo($(table).find('thead'));
      // console.log($(table).find('tr:first'));
    }

    // $(table).addClass('table tablesaw tablesaw-stack').attr('data-tablesaw-mode', 'stack');

    // $(table).find('thead').html(function(id, html) {
    //   return html.replace(/td>/g, 'th>');
    // });
    $(table).find('thead td').each(function () {
      // Create a new element and assign it attributes from the current element
      const NewElement = $('<th />');
      $.each(this.attributes, (i, attrib) => {
        $(NewElement).attr(attrib.name, attrib.value);
      });

      // Replace the current element with the new one and carry over the contents
      $(this).replaceWith(function () {
        return $(NewElement).append($(this).contents());
      });
    });
  });
  $('table').wrap('<div class="overflow-x-auto"></div>');

  // $('table').each(function(index, table){
  //   Tablesaw.$(table).trigger('enhance.tablesaw');
  // });

  // Tablesaw.init();
  $('.icon-toggle').popover();

  $('.dropdown-menu-select select').on('change', function (e) {
    const home_url = $('body').data('home');
    // console.log(home_url);
    const value = $(this).val();
    // console.log(value);
    window.location = `${home_url}?page_id=${value}`;
    return false;
  });

  $('.open-busca-mobile').on('click', (e) => {
    const button = e.currentTarget;
    const menu_normal = document.querySelector(button.getAttribute('data-target')).querySelector('.menu-normal');
    const menu_busca = document.querySelector(button.getAttribute('data-target')).querySelector('.menu-busca');

    menu_normal.classList.add('opacity-0', 'z-10');
    menu_normal.classList.remove('z-20');

    menu_busca.classList.add('opacity-1', 'z-20');
    menu_busca.classList.remove('opacity-0', 'z-10');

    return false;
  });

  $('.close-search-mobile').on('click', (e) => {
    const button = e.currentTarget;
    const menu_normal = document.querySelector(button.getAttribute('data-target')).querySelector('.menu-normal');
    const menu_busca = document.querySelector(button.getAttribute('data-target')).querySelector('.menu-busca');

    menu_normal.classList.add('z-20');
    menu_normal.classList.remove('z-10', 'opacity-0');

    menu_busca.classList.add('opacity-0', 'z-10');
    menu_busca.classList.remove('opacity-1', 'z-20');

    return false;
  });

  $('.js-offmenu-toggle').on('click', () => {
    $('body').removeClass('show-search');
    if ($('body').hasClass('is-showing-menu')) {
      // console.log('ativo');
      if ($('.c-box-menu__wrap').hasClass('submenu-aberto')) {
        $('.c-box-menu__wrap').addClass('submenu-fechou');

        // $('.c-box-menu__wrap').
        // $('.c-box-menu__wrap').removeClass('submenu-fechou');

        setTimeout(() => {
          $('body').toggleClass('is-showing-menu');
          $('.js-offmenu-toggle').toggleClass('is-active');
          $('.submenu-hidden').hide();
          $('.c-box-menu__wrap').removeClass('submenu-fechou').removeClass('submenu-aberto');
        }, 600);
      } else {
        $('body').toggleClass('is-showing-menu');
        $('.js-offmenu-toggle').toggleClass('is-active');
      } // $('.c-box-menu__wrap').removeClass('submenu-aberto');
      // $('.submenu-hidden').hide();
    } else {
      $('body').toggleClass('is-showing-menu');
      $('.js-offmenu-toggle').toggleClass('is-active');
    }

    $('.open-next').on('click', (e) => {
      const $this = $(e.currentTarget);
      // $(e).preventDefault();
      $('.submenu-hidden').hide();
      $(`.${$this.data('target')}`).show();
      $('.c-box-menu__wrap').toggleClass('submenu-aberto');
      // console.log($(this).data('target'));
      // .children()
      // .last());
      // $(this)
      //   .parent()
      //   .children()
      //   .last()
      //   .slideToggle();
      // $(this).parent().toggleClass('submenu-aberto');
      return false;
      // console.log($(e.target).prop('tagName'));
      // return false;
    });

    // Calculate scroll length and apply it in the menu wrapper to position it correctly
    // yOffset = $(window).scrollTop() + "px";
    // $(".c-mega-menu__position-wrapper").css("marginTop", yOffset);
  });

  $('.close-submenu').on('click', () => {
    // $('.c-box-menu__wrap').addClass('submenu-fechou');

    $('.c-box-menu__wrap').addClass('submenu-fechando');
    // $('.c-box-menu__wrap').removeClass('submenu-fechou');
    setTimeout(() => {
      $('.c-box-menu__wrap').removeClass('submenu-aberto').removeClass('submenu-fechando');
      $('.submenu-hidden').hide();
    }, 700);
  });

  const options = {
    // root: ,
    // rootMargin: '0px 0px -100%',
    threshold: 0,
  };

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      // console.log(entry);
      if (!entry.isIntersecting) {
        document.querySelector('.menu-fixo').classList.add('translate-y-0');
        document.querySelector('.menu-fixo').classList.remove('-translate-y-full');
      } else {
        document.querySelector('.menu-fixo').classList.add('-translate-y-full');
        document.querySelector('.menu-fixo').classList.remove('translate-y-0');
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);
  observer.observe(document.querySelector('.header-full-wrapper'));

  $('.js-open-dep-modal').on('click', function () {
    const id_depoimento = $(this).data('id');
    MicroModal.show('assine-modal', {
      disableScroll: true,
      closeTrigger: 'data-micromodal-close',
      debugMode: true,
      onShow: (modal) => {
        const idModal = modal.id;
        // console.log(modal);
        // console.log(id_depoimento);
        const home = jQuery('body').data('home');
        const link = `${home}/ajax/depoimento/${id_depoimento}/`;
        console.log(link);
        jQuery(modal)
          .find('.modal__content')
          .html(jQuery('.spinner').html());
        jQuery.ajaxSetup({ async: false });

        jQuery.get(link, (data) => {
          // jQuery(data).find('li.form-post-id input').val(jQuery('.post_id').val());
          console.log(data);
          jQuery(modal)
            .find('.modal__content')
            .html(data);

          // jQuery('li.form-post-id input').val(jQuery('.post_id').val());
          // jQuery('.modal__title').text()
        });
      },
    });

    return false;
  });

  $('#main-tab').easyResponsiveTabs({
    type: 'default', // Types: default, vertical, accordion
    width: 'auto', // auto or any width like 600px
    fit: true, // 100% fit in a container
    tabidentify: 'tab_1', // The tab groups identifier
    activetab_bg: '#fefdec',
    inactive_bg: '#acd460',
    active_border_color: '#ededed',
    active_content_border_color: '#4d553d',
    activate(event) { // Callback function if tab is switched
      const $tab = $(this);
      const $info = $('#nested-tabInfo');
      const $name = $('span', $info);
      $name.text($tab.text());
      $info.show();
    },
  });

  // $('.list-group').collapse({parent : 'children', toggle : true});
  // $('.children').collapse('toggle');

  $.each($('.sidebar .page_item_has_children > a'), (i, link) => {
    // Adds icon
    // $(this).append('<i class="collapse-icon-toggle fa fa-angle-down"></i>');
    // Collapse children
    // $('.children').addClass('collapse').collapse({ toggle: false });
    // If is active page, open parent
    $('.current_page_item, .current_page_parent').parent().addClass('in');
    $('.current_page_parent').children('a').addClass('opened');
    // If is active page, open itself
    $('.page_item_has_children.current_page_item').children('a').addClass('opened');
    $('.page_item_has_children.current_page_item').children('.children').addClass('in');

    $(link).on(
      'click',
      '.collapse-icon-toggle',
      (event) => {
        // console.log($(link));
        // console.log($(link).next('.children'));
        // console.log('aqui');
        event.preventDefault();
        $(link).next('.children').collapse('toggle');
      },
    );
  });

  $('.children').on('shown.bs.collapse', function (event) {
    $(this).prev().addClass('opened');
    event.stopPropagation();
  });

  $('.children').on('hidden.bs.collapse', function (event) {
    $(this).prev().removeClass('opened');
    event.stopPropagation();
  });

  $('.js-event-category').on('change', function (e) {
    window.location = $(this).find(':selected').data('slug');
  });
}); // Close Main Bracket

const opts = {
  lines: 13, // The number of lines to draw
  length: 28, // The length of each line
  width: 8, // The line thickness
  radius: 0, // The radius of the inner circle
  scale: 1, // Scales overall size of the spinner
  corners: 1, // Corner roundness (0..1)
  color: '#acd460', // #rgb or #rrggbb or array of colors
  opacity: 0.3, // Opacity of the lines
  rotate: 21, // The rotation offset
  direction: 1, // 1: clockwise, -1: counterclockwise
  speed: 0.8, // Rounds per second
  trail: 60, // Afterglow percentage
  fps: 20, // Frames per second when using setTimeout() as a fallback for CSS
  zIndex: 2e9, // The z-index (defaults to 2000000000)
  className: 'spinner', // The CSS class to assign to the spinner
  top: '50%', // Top position relative to parent
  left: '50%', // Left position relative to parent
  shadow: false, // Whether to render a shadow
  hwaccel: true, // Whether to use hardware acceleration
  position: 'fixed', // Element positioning
};

// Depoimento Modal AJAX

// $('.js-open-info-modal').click(function (e) {
//   e.preventDefault();
//   // console.log(e.target.href);
//   //GA Send Event
//   // ga('send', {
//   //   hitType: 'event',
//   //   eventCategory: 'Info e Preços',
//   //   eventAction: 'button_click',
//   //   eventLabel: e.target.href
//   // });

//   var spinner = new Spinner(opts).spin();
//   siteBody = $('html')[0];
//   siteBody.appendChild(spinner.el);

//   $('#infoModalForm').modal('show');
//   spinner.stop();

//   return false;
// });

// $('.js-btn-landing').click(function(e){
//     e.preventDefault();
//   setTimeout(function(){
//     $("#gform_wrapper_14")[0].scrollIntoView(true);
//     $("#input_14_1_3").focus();
//     $('.landing-form_wrapper').addClass('shaking');
//   },100);
//     $('.landing-form_wrapper').removeClass('shaking');
//     return false;
// });

$('.js-btn-landing').on('click', function (e) {
  e.preventDefault();
  wrapper = $(this).attr('href');
  mixpanel.track('Ver mais info - click');
  setTimeout(() => {
    $(wrapper)[0].scrollIntoView(true);
    // Add .js-focus in the CSS of the input to be focused after clicking
    $('.js-focus input').focus();
    $('.landing-form_wrapper').addClass('shaking');
  }, 100);
  $('.landing-form_wrapper').removeClass('shaking');
  return false;
});
